import React, { useEffect, useRef } from "react";

// Leaflet is loaded via CDN script (index.html) to avoid npm deps.
export default function LeafletMap({
  restaurant,
  user,
  rider,
  center,
  height = 360,
  showRoute = true,
}) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const markersRef = useRef({});
  const lineRef = useRef(null);

  useEffect(() => {
    const L = window.L;
    if (!L || !ref.current) return;
    if (!mapRef.current) {
      const c = center || restaurant || { lat: 25.8944, lng: 93.7253 };
      mapRef.current = L.map(ref.current, { zoomControl: false, attributionControl: false }).setView([c.lat, c.lng], 14);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(mapRef.current);
      L.control.zoom({ position: "bottomright" }).addTo(mapRef.current);
    }
  }, [center, restaurant]);

  useEffect(() => {
    const L = window.L;
    if (!L || !mapRef.current) return;
    const map = mapRef.current;

    const upsert = (key, point, cls, label) => {
      if (!point || point.lat == null) return;
      const icon = L.divIcon({
        className: "",
        html: `<div class="mj-marker ${cls}">${label}</div>`,
        iconSize: [36, 36],
        iconAnchor: [18, 18],
      });
      if (markersRef.current[key]) {
        markersRef.current[key].setLatLng([point.lat, point.lng]);
      } else {
        markersRef.current[key] = L.marker([point.lat, point.lng], { icon }).addTo(map);
      }
    };

    upsert("resto", restaurant, "resto", "M");
    upsert("user", user, "user", "U");
    upsert("rider", rider, "rider", "R");

    // Route line
    if (showRoute) {
      const pts = [];
      if (restaurant) pts.push([restaurant.lat, restaurant.lng]);
      if (rider && rider.lat != null) pts.push([rider.lat, rider.lng]);
      if (user) pts.push([user.lat, user.lng]);
      if (lineRef.current) { map.removeLayer(lineRef.current); lineRef.current = null; }
      if (pts.length >= 2) {
        lineRef.current = L.polyline(pts, { color: "#0A0A0A", weight: 3, opacity: 0.85, dashArray: "6, 8" }).addTo(map);
      }
    }

    // Fit bounds
    const points = [restaurant, user, rider].filter((p) => p && p.lat != null);
    if (points.length >= 2) {
      const b = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
      map.fitBounds(b, { padding: [40, 40], maxZoom: 15 });
    }
  }, [restaurant, user, rider, showRoute]);

  return <div ref={ref} style={{ height, width: "100%" }} className="mj-map rounded-2xl overflow-hidden" data-testid="leaflet-map" />;
}
